export interface CountryType {
    id: string;
    label: string;
    phone: string;
}

export const countries = [
    { id: 'AD', label: 'Andorra', phone: '376' },
    { id: 'AE', label: 'United Arab Emirates', phone: '971' },
    { id: 'AF', label: 'Afghanistan', phone: '93' },
    { id: 'AG', label: 'Antigua and Barbuda', phone: '1-268' },
    { id: 'AI', label: 'Anguilla', phone: '1-264' },
    { id: 'AL', label: 'Albania', phone: '355' },
    { id: 'AM', label: 'Armenia', phone: '374' },
    { id: 'AO', label: 'Angola', phone: '244' },
    { id: 'AQ', label: 'Antarctica', phone: '672' },
    { id: 'AR', label: 'Argentina', phone: '54' },
    { id: 'AS', label: 'American Samoa', phone: '1-684' },
    { id: 'AT', label: 'Austria', phone: '43' },
    { id: 'AU', label: 'Australia', phone: '61', suggested: true },
    { id: 'AW', label: 'Aruba', phone: '297' },
    { id: 'AX', label: 'Alland Islands', phone: '358' },
    { id: 'AZ', label: 'Azerbaijan', phone: '994' },
    { id: 'BA', label: 'Bosnia and Herzegovina', phone: '387' },
    { id: 'BB', label: 'Barbados', phone: '1-246' },
    { id: 'BD', label: 'Bangladesh', phone: '880' },
    { id: 'BE', label: 'Belgium', phone: '32' },
    { id: 'BF', label: 'Burkina Faso', phone: '226' },
    { id: 'BG', label: 'Bulgaria', phone: '359' },
    { id: 'BH', label: 'Bahrain', phone: '973' },
    { id: 'BI', label: 'Burundi', phone: '257' },
    { id: 'BJ', label: 'Benin', phone: '229' },
    { id: 'BL', label: 'Saint Barthelemy', phone: '590' },
    { id: 'BM', label: 'Bermuda', phone: '1-441' },
    { id: 'BN', label: 'Brunei Darussalam', phone: '673' },
    { id: 'BO', label: 'Bolivia', phone: '591' },
    { id: 'BR', label: 'Brazil', phone: '55' },
    { id: 'BS', label: 'Bahamas', phone: '1-242' },
    { id: 'BT', label: 'Bhutan', phone: '975' },
    { id: 'BV', label: 'Bouvet Island', phone: '47' },
    { id: 'BW', label: 'Botswana', phone: '267' },
    { id: 'BY', label: 'Belarus', phone: '375' },
    { id: 'BZ', label: 'Belize', phone: '501' },
    { id: 'CA', label: 'Canada', phone: '1', suggested: true },
    { id: 'CC', label: 'Cocos (Keeling) Islands', phone: '61' },
    { id: 'CD', label: 'Congo, Democratic Republic of the', phone: '243' },
    { id: 'CF', label: 'Central African Republic', phone: '236' },
    { id: 'CG', label: 'Congo, Republic of the', phone: '242' },
    { id: 'CH', label: 'Switzerland', phone: '41' },
    { id: 'CI', label: "Cote d'Ivoire", phone: '225' },
    { id: 'CK', label: 'Cook Islands', phone: '682' },
    { id: 'CL', label: 'Chile', phone: '56' },
    { id: 'CM', label: 'Cameroon', phone: '237' },
    { id: 'CN', label: 'China', phone: '86' },
    { id: 'CO', label: 'Colombia', phone: '57' },
    { id: 'CR', label: 'Costa Rica', phone: '506' },
    { id: 'CU', label: 'Cuba', phone: '53' },
    { id: 'CV', label: 'Cape Verde', phone: '238' },
    { id: 'CW', label: 'Curacao', phone: '599' },
    { id: 'CX', label: 'Christmas Island', phone: '61' },
    { id: 'CY', label: 'Cyprus', phone: '357' },
    { id: 'CZ', label: 'Czech Republic', phone: '420' },
    { id: 'DE', label: 'Germany', phone: '49', suggested: true },
    { id: 'DJ', label: 'Djibouti', phone: '253' },
    { id: 'DK', label: 'Denmark', phone: '45' },
    { id: 'DM', label: 'Dominica', phone: '1-767' },
    { id: 'DO', label: 'Dominican Republic', phone: '1-809' },
    { id: 'DZ', label: 'Algeria', phone: '213' },
    { id: 'EC', label: 'Ecuador', phone: '593' },
    { id: 'EE', label: 'Estonia', phone: '372' },
    { id: 'EG', label: 'Egypt', phone: '20' },
    { id: 'EH', label: 'Western Sahara', phone: '212' },
    { id: 'ER', label: 'Eritrea', phone: '291' },
    { id: 'ES', label: 'Spain', phone: '34' },
    { id: 'ET', label: 'Ethiopia', phone: '251' },
    { id: 'FI', label: 'Finland', phone: '358' },
    { id: 'FJ', label: 'Fiji', phone: '679' },
    { id: 'FK', label: 'Falkland Islands (Malvinas)', phone: '500' },
    { id: 'FM', label: 'Micronesia, Federated States of', phone: '691' },
    { id: 'FO', label: 'Faroe Islands', phone: '298' },
    { id: 'FR', label: 'France', phone: '33', suggested: true },
    { id: 'GA', label: 'Gabon', phone: '241' },
    { id: 'GB', label: 'United Kingdom', phone: '44' },
    { id: 'GD', label: 'Grenada', phone: '1-473' },
    { id: 'GE', label: 'Georgia', phone: '995' },
    { id: 'GF', label: 'French Guiana', phone: '594' },
    { id: 'GG', label: 'Guernsey', phone: '44' },
    { id: 'GH', label: 'Ghana', phone: '233' },
    { id: 'GI', label: 'Gibraltar', phone: '350' },
    { id: 'GL', label: 'Greenland', phone: '299' },
    { id: 'GM', label: 'Gambia', phone: '220' },
    { id: 'GN', label: 'Guinea', phone: '224' },
    { id: 'GP', label: 'Guadeloupe', phone: '590' },
    { id: 'GQ', label: 'Equatorial Guinea', phone: '240' },
    { id: 'GR', label: 'Greece', phone: '30' },
    { id: 'GS', label: 'South Georgia and the South Sandwich Islands', phone: '500' },
    { id: 'GT', label: 'Guatemala', phone: '502' },
    { id: 'GU', label: 'Guam', phone: '1-671' },
    { id: 'GW', label: 'Guinea-Bissau', phone: '245' },
    { id: 'GY', label: 'Guyana', phone: '592' },
    { id: 'HK', label: 'Hong Kong', phone: '852' },
    { id: 'HM', label: 'Heard Island and McDonald Islands', phone: '672' },
    { id: 'HN', label: 'Honduras', phone: '504' },
    { id: 'HR', label: 'Croatia', phone: '385' },
    { id: 'HT', label: 'Haiti', phone: '509' },
    { id: 'HU', label: 'Hungary', phone: '36' },
    { id: 'ID', label: 'Indonesia', phone: '62' },
    { id: 'IE', label: 'Ireland', phone: '353' },
    { id: 'IL', label: 'Israel', phone: '972' },
    { id: 'IM', label: 'Isle of Man', phone: '44' },
    { id: 'IN', label: 'India', phone: '91' },
    { id: 'IO', label: 'British Indian Ocean Territory', phone: '246' },
    { id: 'IQ', label: 'Iraq', phone: '964' },
    { id: 'IR', label: 'Iran, Islamic Republic of', phone: '98' },
    { id: 'IS', label: 'Iceland', phone: '354' },
    { id: 'IT', label: 'Italy', phone: '39' },
    { id: 'JE', label: 'Jersey', phone: '44' },
    { id: 'JM', label: 'Jamaica', phone: '1-876' },
    { id: 'JO', label: 'Jordan', phone: '962' },
    { id: 'JP', label: 'Japan', phone: '81', suggested: true },
    { id: 'KE', label: 'Kenya', phone: '254' },
    { id: 'KG', label: 'Kyrgyzstan', phone: '996' },
    { id: 'KH', label: 'Cambodia', phone: '855' },
    { id: 'KI', label: 'Kiribati', phone: '686' },
    { id: 'KM', label: 'Comoros', phone: '269' },
    { id: 'KN', label: 'Saint Kitts and Nevis', phone: '1-869' },
    { id: 'KP', label: "Korea, Democratic People's Republic of", phone: '850' },
    { id: 'KR', label: 'Korea, Republic of', phone: '82' },
    { id: 'KW', label: 'Kuwait', phone: '965' },
    { id: 'KY', label: 'Cayman Islands', phone: '1-345' },
    { id: 'KZ', label: 'Kazakhstan', phone: '7' },
    { id: 'LA', label: "Lao People's Democratic Republic", phone: '856' },
    { id: 'LB', label: 'Lebanon', phone: '961' },
    { id: 'LC', label: 'Saint Lucia', phone: '1-758' },
    { id: 'LI', label: 'Liechtenstein', phone: '423' },
    { id: 'LK', label: 'Sri Lanka', phone: '94' },
    { id: 'LR', label: 'Liberia', phone: '231' },
    { id: 'LS', label: 'Lesotho', phone: '266' },
    { id: 'LT', label: 'Lithuania', phone: '370' },
    { id: 'LU', label: 'Luxembourg', phone: '352' },
    { id: 'LV', label: 'Latvia', phone: '371' },
    { id: 'LY', label: 'Libya', phone: '218' },
    { id: 'MA', label: 'Morocco', phone: '212' },
    { id: 'MC', label: 'Monaco', phone: '377' },
    { id: 'MD', label: 'Moldova, Republic of', phone: '373' },
    { id: 'ME', label: 'Montenegro', phone: '382' },
    { id: 'MF', label: 'Saint Martin (French part)', phone: '590' },
    { id: 'MG', label: 'Madagascar', phone: '261' },
    { id: 'MH', label: 'Marshall Islands', phone: '692' },
    { id: 'MK', label: 'Macedonia, the Former Yugoslav Republic of', phone: '389' },
    { id: 'ML', label: 'Mali', phone: '223' },
    { id: 'MM', label: 'Myanmar', phone: '95' },
    { id: 'MN', label: 'Mongolia', phone: '976' },
    { id: 'MO', label: 'Macao', phone: '853' },
    { id: 'MP', label: 'Northern Mariana Islands', phone: '1-670' },
    { id: 'MQ', label: 'Martinique', phone: '596' },
    { id: 'MR', label: 'Mauritania', phone: '222' },
    { id: 'MS', label: 'Montserrat', phone: '1-664' },
    { id: 'MT', label: 'Malta', phone: '356' },
    { id: 'MU', label: 'Mauritius', phone: '230' },
    { id: 'MV', label: 'Maldives', phone: '960' },
    { id: 'MW', label: 'Malawi', phone: '265' },
    { id: 'MX', label: 'Mexico', phone: '52' },
    { id: 'MY', label: 'Malaysia', phone: '60' },
    { id: 'MZ', label: 'Mozambique', phone: '258' },
    { id: 'NA', label: 'Namibia', phone: '264' },
    { id: 'NC', label: 'New Caledonia', phone: '687' },
    { id: 'NE', label: 'Niger', phone: '227' },
    { id: 'NF', label: 'Norfolk Island', phone: '672' },
    { id: 'NG', label: 'Nigeria', phone: '234' },
    { id: 'NI', label: 'Nicaragua', phone: '505' },
    { id: 'NL', label: 'Netherlands', phone: '31' },
    { id: 'NO', label: 'Norway', phone: '47' },
    { id: 'NP', label: 'Nepal', phone: '977' },
    { id: 'NR', label: 'Nauru', phone: '674' },
    { id: 'NU', label: 'Niue', phone: '683' },
    { id: 'NZ', label: 'New Zealand', phone: '64' },
    { id: 'OM', label: 'Oman', phone: '968' },
    { id: 'PA', label: 'Panama', phone: '507' },
    { id: 'PE', label: 'Peru', phone: '51' },
    { id: 'PF', label: 'French Polynesia', phone: '689' },
    { id: 'PG', label: 'Papua New Guinea', phone: '675' },
    { id: 'PH', label: 'Philippines', phone: '63' },
    { id: 'PK', label: 'Pakistan', phone: '92' },
    { id: 'PL', label: 'Poland', phone: '48' },
    { id: 'PM', label: 'Saint Pierre and Miquelon', phone: '508' },
    { id: 'PN', label: 'Pitcairn', phone: '870' },
    { id: 'PR', label: 'Puerto Rico', phone: '1' },
    { id: 'PS', label: 'Palestine, State of', phone: '970' },
    { id: 'PT', label: 'Portugal', phone: '351' },
    { id: 'PW', label: 'Palau', phone: '680' },
    { id: 'PY', label: 'Paraguay', phone: '595' },
    { id: 'QA', label: 'Qatar', phone: '974' },
    { id: 'RE', label: 'Reunion', phone: '262' },
    { id: 'RO', label: 'Romania', phone: '40' },
    { id: 'RS', label: 'Serbia', phone: '381' },
    { id: 'RU', label: 'Russian Federation', phone: '7' },
    { id: 'RW', label: 'Rwanda', phone: '250' },
    { id: 'SA', label: 'Saudi Arabia', phone: '966' },
    { id: 'SB', label: 'Solomon Islands', phone: '677' },
    { id: 'SC', label: 'Seychelles', phone: '248' },
    { id: 'SD', label: 'Sudan', phone: '249' },
    { id: 'SE', label: 'Sweden', phone: '46' },
    { id: 'SG', label: 'Singapore', phone: '65' },
    { id: 'SH', label: 'Saint Helena', phone: '290' },
    { id: 'SI', label: 'Slovenia', phone: '386' },
    { id: 'SJ', label: 'Svalbard and Jan Mayen', phone: '47' },
    { id: 'SK', label: 'Slovakia', phone: '421' },
    { id: 'SL', label: 'Sierra Leone', phone: '232' },
    { id: 'SM', label: 'San Marino', phone: '378' },
    { id: 'SN', label: 'Senegal', phone: '221' },
    { id: 'SO', label: 'Somalia', phone: '252' },
    { id: 'SR', label: 'Suriname', phone: '597' },
    { id: 'SS', label: 'South Sudan', phone: '211' },
    { id: 'ST', label: 'Sao Tome and Principe', phone: '239' },
    { id: 'SV', label: 'El Salvador', phone: '503' },
    { id: 'SX', label: 'Sint Maarten (Dutch part)', phone: '1-721' },
    { id: 'SY', label: 'Syrian Arab Republic', phone: '963' },
    { id: 'SZ', label: 'Swaziland', phone: '268' },
    { id: 'TC', label: 'Turks and Caicos Islands', phone: '1-649' },
    { id: 'TD', label: 'Chad', phone: '235' },
    { id: 'TF', label: 'French Southern Territories', phone: '262' },
    { id: 'TG', label: 'Togo', phone: '228' },
    { id: 'TH', label: 'Thailand', phone: '66' },
    { id: 'TJ', label: 'Tajikistan', phone: '992' },
    { id: 'TK', label: 'Tokelau', phone: '690' },
    { id: 'TL', label: 'Timor-Leste', phone: '670' },
    { id: 'TM', label: 'Turkmenistan', phone: '993' },
    { id: 'TN', label: 'Tunisia', phone: '216' },
    { id: 'TO', label: 'Tonga', phone: '676' },
    { id: 'TR', label: 'Turkey', phone: '90' },
    { id: 'TT', label: 'Trinidad and Tobago', phone: '1-868' },
    { id: 'TV', label: 'Tuvalu', phone: '688' },
    { id: 'TW', label: 'Taiwan, Province of China', phone: '886' },
    { id: 'TZ', label: 'United Republic of Tanzania', phone: '255' },
    { id: 'UA', label: 'Ukraine', phone: '380' },
    { id: 'UG', label: 'Uganda', phone: '256' },
    { id: 'US', label: 'United States', phone: '1', suggested: true },
    { id: 'UY', label: 'Uruguay', phone: '598' },
    { id: 'UZ', label: 'Uzbekistan', phone: '998' },
    { id: 'VA', label: 'Holy See (Vatican City State)', phone: '379' },
    { id: 'VC', label: 'Saint Vincent and the Grenadines', phone: '1-784' },
    { id: 'VE', label: 'Venezuela', phone: '58' },
    { id: 'VG', label: 'British Virgin Islands', phone: '1-284' },
    { id: 'VI', label: 'US Virgin Islands', phone: '1-340' },
    { id: 'VN', label: 'Vietnam', phone: '84' },
    { id: 'VU', label: 'Vanuatu', phone: '678' },
    { id: 'WF', label: 'Wallis and Futuna', phone: '681' },
    { id: 'WS', label: 'Samoa', phone: '685' },
    { id: 'XK', label: 'Kosovo', phone: '383' },
    { id: 'YE', label: 'Yemen', phone: '967' },
    { id: 'YT', label: 'Mayotte', phone: '262' },
    { id: 'ZA', label: 'South Africa', phone: '27' },
    { id: 'ZM', label: 'Zambia', phone: '260' },
    { id: 'ZW', label: 'Zimbabwe', phone: '263' },
];

// export const countries = [
// 	{ id: 'AD', label: 'Andorra', phone: '376' },
// 	{ id: 'AE', label: 'United Arab Emirates', phone: '971' },
// 	{ id: 'AF', label: 'Afghanistan', phone: '93' },
// 	{ id: 'AG', label: 'Antigua and Barbuda', phone: '1-268' },
// 	{ id: 'AI', label: 'Anguilla', phone: '1-264' },
// 	{ id: 'AL', label: 'Albania', phone: '355' },
// 	{ id: 'AM', label: 'Armenia', phone: '374' },
// 	{ id: 'AO', label: 'Angola', phone: '244' },
// 	{ id: 'AQ', label: 'Antarctica', phone: '672' },
// 	{ id: 'AR', label: 'Argentina', phone: '54' },
// 	{ id: 'AS', label: 'American Samoa', phone: '1-684' },
// 	{ id: 'AT', label: 'Austria', phone: '43' },
// 	{ id: 'AU', label: 'Australia', phone: '61', suggested: true },
// 	{ id: 'AW', label: 'Aruba', phone: '297' },
// 	{ id: 'AX', label: 'Alland Islands', phone: '358' },
// 	{ id: 'AZ', label: 'Azerbaijan', phone: '994' },
// 	{ id: 'BA', label: 'Bosnia and Herzegovina', phone: '387' },
// 	{ id: 'BB', label: 'Barbados', phone: '1-246' },
// 	{ id: 'BD', label: 'Bangladesh', phone: '880' },
// 	{ id: 'BE', label: 'Belgium', phone: '32' },
// 	{ id: 'BF', label: 'Burkina Faso', phone: '226' },
// 	{ id: 'BG', label: 'Bulgaria', phone: '359' },
// 	{ id: 'BH', label: 'Bahrain', phone: '973' },
// 	{ id: 'BI', label: 'Burundi', phone: '257' },
// 	{ id: 'BJ', label: 'Benin', phone: '229' },
// 	{ id: 'BL', label: 'Saint Barthelemy', phone: '590' },
// 	{ id: 'BM', label: 'Bermuda', phone: '1-441' },
// 	{ id: 'BN', label: 'Brunei Darussalam', phone: '673' },
// 	{ id: 'BO', label: 'Bolivia', phone: '591' },
// 	{ id: 'BR', label: 'Brazil', phone: '55' },
// 	{ id: 'BS', label: 'Bahamas', phone: '1-242' },
// 	{ id: 'BT', label: 'Bhutan', phone: '975' },
// 	{ id: 'BV', label: 'Bouvet Island', phone: '47' },
// 	{ id: 'BW', label: 'Botswana', phone: '267' },
// 	{ id: 'BY', label: 'Belarus', phone: '375' },
// 	{ id: 'BZ', label: 'Belize', phone: '501' },
// 	{ id: 'CA', label: 'Canada', phone: '1', suggested: true },
// 	{ id: 'CC', label: 'Cocos (Keeling) Islands', phone: '61' },
// 	{ id: 'CD', label: 'Congo, Democratic Republic of the', phone: '243' },
// 	{ id: 'CF', label: 'Central African Republic', phone: '236' },
// 	{ id: 'CG', label: 'Congo, Republic of the', phone: '242' },
// 	{ id: 'CH', label: 'Switzerland', phone: '41' },
// 	{ id: 'CI', label: "Cote d'Ivoire", phone: '225' },
// 	{ id: 'CK', label: 'Cook Islands', phone: '682' },
// 	{ id: 'CL', label: 'Chile', phone: '56' },
// 	{ id: 'CM', label: 'Cameroon', phone: '237' },
// 	{ id: 'CN', label: 'China', phone: '86' },
// 	{ id: 'CO', label: 'Colombia', phone: '57' },
// 	{ id: 'CR', label: 'Costa Rica', phone: '506' },
// 	{ id: 'CU', label: 'Cuba', phone: '53' },
// 	{ id: 'CV', label: 'Cape Verde', phone: '238' },
// 	{ id: 'CW', label: 'Curacao', phone: '599' },
// 	{ id: 'CX', label: 'Christmas Island', phone: '61' },
// 	{ id: 'CY', label: 'Cyprus', phone: '357' },
// 	{ id: 'CZ', label: 'Czech Republic', phone: '420' },
// 	{ id: 'DE', label: 'Germany', phone: '49', suggested: true },
// 	{ id: 'DJ', label: 'Djibouti', phone: '253' },
// 	{ id: 'DK', label: 'Denmark', phone: '45' },
// 	{ id: 'DM', label: 'Dominica', phone: '1-767' },
// 	{ id: 'DO', label: 'Dominican Republic', phone: '1-809' },
// 	{ id: 'DZ', label: 'Algeria', phone: '213' },
// 	{ id: 'EC', label: 'Ecuador', phone: '593' },
// 	{ id: 'EE', label: 'Estonia', phone: '372' },
// 	{ id: 'EG', label: 'Egypt', phone: '20' },
// 	{ id: 'EH', label: 'Western Sahara', phone: '212' },
// 	{ id: 'ER', label: 'Eritrea', phone: '291' },
// 	{ id: 'ES', label: 'Spain', phone: '34' },
// 	{ id: 'ET', label: 'Ethiopia', phone: '251' },
// 	{ id: 'FI', label: 'Finland', phone: '358' },
// 	{ id: 'FJ', label: 'Fiji', phone: '679' },
// 	{ id: 'FK', label: 'Falkland Islands (Malvinas)', phone: '500' },
// 	{ id: 'FM', label: 'Micronesia, Federated States of', phone: '691' },
// 	{ id: 'FO', label: 'Faroe Islands', phone: '298' },
// 	{ id: 'FR', label: 'France', phone: '33', suggested: true },
// 	{ id: 'GA', label: 'Gabon', phone: '241' },
// 	{ id: 'GB', label: 'United Kingdom', phone: '44' },
// 	{ id: 'GD', label: 'Grenada', phone: '1-473' },
// 	{ id: 'GE', label: 'Georgia', phone: '995' },
// 	{ id: 'GF', label: 'French Guiana', phone: '594' },
// 	{ id: 'GG', label: 'Guernsey', phone: '44' },
// 	{ id: 'GH', label: 'Ghana', phone: '233' },
// 	{ id: 'GI', label: 'Gibraltar', phone: '350' },
// 	{ id: 'GL', label: 'Greenland', phone: '299' },
// 	{ id: 'GM', label: 'Gambia', phone: '220' },
// 	{ id: 'GN', label: 'Guinea', phone: '224' },
// 	{ id: 'GP', label: 'Guadeloupe', phone: '590' },
// 	{ id: 'GQ', label: 'Equatorial Guinea', phone: '240' },
// 	{ id: 'GR', label: 'Greece', phone: '30' },
// 	{ id: 'GS', label: 'South Georgia and the South Sandwich Islands', phone: '500' },
// 	{ id: 'GT', label: 'Guatemala', phone: '502' },
// 	{ id: 'GU', label: 'Guam', phone: '1-671' },
// 	{ id: 'GW', label: 'Guinea-Bissau', phone: '245' },
// 	{ id: 'GY', label: 'Guyana', phone: '592' },
// 	{ id: 'HK', label: 'Hong Kong', phone: '852' },
// 	{ id: 'HM', label: 'Heard Island and McDonald Islands', phone: '672' },
// 	{ id: 'HN', label: 'Honduras', phone: '504' },
// 	{ id: 'HR', label: 'Croatia', phone: '385' },
// 	{ id: 'HT', label: 'Haiti', phone: '509' },
// 	{ id: 'HU', label: 'Hungary', phone: '36' },
// 	{ id: 'ID', label: 'Indonesia', phone: '62' },
// 	{ id: 'IE', label: 'Ireland', phone: '353' },
// 	{ id: 'IL', label: 'Israel', phone: '972' },
// 	{ id: 'IM', label: 'Isle of Man', phone: '44' },
// 	{ id: 'IN', label: 'India', phone: '91' },
// 	{ id: 'IO', label: 'British Indian Ocean Territory', phone: '246' },
// 	{ id: 'IQ', label: 'Iraq', phone: '964' },
// 	{ id: 'IR', label: 'Iran, Islamic Republic of', phone: '98' },
// 	{ id: 'IS', label: 'Iceland', phone: '354' },
// 	{ id: 'IT', label: 'Italy', phone: '39' },
// 	{ id: 'JE', label: 'Jersey', phone: '44' },
// 	{ id: 'JM', label: 'Jamaica', phone: '1-876' },
// 	{ id: 'JO', label: 'Jordan', phone: '962' },
// 	{ id: 'JP', label: 'Japan', phone: '81', suggested: true },
// 	{ id: 'KE', label: 'Kenya', phone: '254' },
// 	{ id: 'KG', label: 'Kyrgyzstan', phone: '996' },
// 	{ id: 'KH', label: 'Cambodia', phone: '855' },
// 	{ id: 'KI', label: 'Kiribati', phone: '686' },
// 	{ id: 'KM', label: 'Comoros', phone: '269' },
// 	{ id: 'KN', label: 'Saint Kitts and Nevis', phone: '1-869' },
// 	{ id: 'KP', label: "Korea, Democratic People's Republic of", phone: '850' },
// 	{ id: 'KR', label: 'Korea, Republic of', phone: '82' },
// 	{ id: 'KW', label: 'Kuwait', phone: '965' },
// 	{ id: 'KY', label: 'Cayman Islands', phone: '1-345' },
// 	{ id: 'KZ', label: 'Kazakhstan', phone: '7' },
// 	{ id: 'LA', label: "Lao People's Democratic Republic", phone: '856' },
// 	{ id: 'LB', label: 'Lebanon', phone: '961' },
// 	{ id: 'LC', label: 'Saint Lucia', phone: '1-758' },
// 	{ id: 'LI', label: 'Liechtenstein', phone: '423' },
// 	{ id: 'LK', label: 'Sri Lanka', phone: '94' },
// 	{ id: 'LR', label: 'Liberia', phone: '231' },
// 	{ id: 'LS', label: 'Lesotho', phone: '266' },
// 	{ id: 'LT', label: 'Lithuania', phone: '370' },
// 	{ id: 'LU', label: 'Luxembourg', phone: '352' },
// 	{ id: 'LV', label: 'Latvia', phone: '371' },
// 	{ id: 'LY', label: 'Libya', phone: '218' },
// 	{ id: 'MA', label: 'Morocco', phone: '212' },
// 	{ id: 'MC', label: 'Monaco', phone: '377' },
// 	{ id: 'MD', label: 'Moldova, Republic of', phone: '373' },
// 	{ id: 'ME', label: 'Montenegro', phone: '382' },
// 	{ id: 'MF', label: 'Saint Martin (French part)', phone: '590' },
// 	{ id: 'MG', label: 'Madagascar', phone: '261' },
// 	{ id: 'MH', label: 'Marshall Islands', phone: '692' },
// 	{ id: 'MK', label: 'Macedonia, the Former Yugoslav Republic of', phone: '389' },
// 	{ id: 'ML', label: 'Mali', phone: '223' },
// 	{ id: 'MM', label: 'Myanmar', phone: '95' },
// 	{ id: 'MN', label: 'Mongolia', phone: '976' },
// 	{ id: 'MO', label: 'Macao', phone: '853' },
// 	{ id: 'MP', label: 'Northern Mariana Islands', phone: '1-670' },
// 	{ id: 'MQ', label: 'Martinique', phone: '596' },
// 	{ id: 'MR', label: 'Mauritania', phone: '222' },
// 	{ id: 'MS', label: 'Montserrat', phone: '1-664' },
// 	{ id: 'MT', label: 'Malta', phone: '356' },
// 	{ id: 'MU', label: 'Mauritius', phone: '230' },
// 	{ id: 'MV', label: 'Maldives', phone: '960' },
// 	{ id: 'MW', label: 'Malawi', phone: '265' },
// 	{ id: 'MX', label: 'Mexico', phone: '52' },
// 	{ id: 'MY', label: 'Malaysia', phone: '60' },
// 	{ id: 'MZ', label: 'Mozambique', phone: '258' },
// 	{ id: 'NA', label: 'Namibia', phone: '264' },
// 	{ id: 'NC', label: 'New Caledonia', phone: '687' },
// 	{ id: 'NE', label: 'Niger', phone: '227' },
// 	{ id: 'NF', label: 'Norfolk Island', phone: '672' },
// 	{ id: 'NG', label: 'Nigeria', phone: '234' },
// 	{ id: 'NI', label: 'Nicaragua', phone: '505' },
// 	{ id: 'NL', label: 'Netherlands', phone: '31' },
// 	{ id: 'NO', label: 'Norway', phone: '47' },
// 	{ id: 'NP', label: 'Nepal', phone: '977' },
// 	{ id: 'NR', label: 'Nauru', phone: '674' },
// 	{ id: 'NU', label: 'Niue', phone: '683' },
// 	{ id: 'NZ', label: 'New Zealand', phone: '64' },
// 	{ id: 'OM', label: 'Oman', phone: '968' },
// 	{ id: 'PA', label: 'Panama', phone: '507' },
// 	{ id: 'PE', label: 'Peru', phone: '51' },
// 	{ id: 'PF', label: 'French Polynesia', phone: '689' },
// 	{ id: 'PG', label: 'Papua New Guinea', phone: '675' },
// 	{ id: 'PH', label: 'Philippines', phone: '63' },
// 	{ id: 'PK', label: 'Pakistan', phone: '92' },
// 	{ id: 'PL', label: 'Poland', phone: '48' },
// 	{ id: 'PM', label: 'Saint Pierre and Miquelon', phone: '508' },
// 	{ id: 'PN', label: 'Pitcairn', phone: '870' },
// 	{ id: 'PR', label: 'Puerto Rico', phone: '1' },
// 	{ id: 'PS', label: 'Palestine, State of', phone: '970' },
// 	{ id: 'PT', label: 'Portugal', phone: '351' },
// 	{ id: 'PW', label: 'Palau', phone: '680' },
// 	{ id: 'PY', label: 'Paraguay', phone: '595' },
// 	{ id: 'QA', label: 'Qatar', phone: '974' },
// 	{ id: 'RE', label: 'Reunion', phone: '262' },
// 	{ id: 'RO', label: 'Romania', phone: '40' },
// 	{ id: 'RS', label: 'Serbia', phone: '381' },
// 	{ id: 'RU', label: 'Russian Federation', phone: '7' },
// 	{ id: 'RW', label: 'Rwanda', phone: '250' },
// 	{ id: 'SA', label: 'Saudi Arabia', phone: '966' },
// 	{ id: 'SB', label: 'Solomon Islands', phone: '677' },
// 	{ id: 'SC', label: 'Seychelles', phone: '248' },
// 	{ id: 'SD', label: 'Sudan', phone: '249' },
// 	{ id: 'SE', label: 'Sweden', phone: '46' },
// 	{ id: 'SG', label: 'Singapore', phone: '65' },
// 	{ id: 'SH', label: 'Saint Helena', phone: '290' },
// 	{ id: 'SI', label: 'Slovenia', phone: '386' },
// 	{ id: 'SJ', label: 'Svalbard and Jan Mayen', phone: '47' },
// 	{ id: 'SK', label: 'Slovakia', phone: '421' },
// 	{ id: 'SL', label: 'Sierra Leone', phone: '232' },
// 	{ id: 'SM', label: 'San Marino', phone: '378' },
// 	{ id: 'SN', label: 'Senegal', phone: '221' },
// 	{ id: 'SO', label: 'Somalia', phone: '252' },
// 	{ id: 'SR', label: 'Suriname', phone: '597' },
// 	{ id: 'SS', label: 'South Sudan', phone: '211' },
// 	{ id: 'ST', label: 'Sao Tome and Principe', phone: '239' },
// 	{ id: 'SV', label: 'El Salvador', phone: '503' },
// 	{ id: 'SX', label: 'Sint Maarten (Dutch part)', phone: '1-721' },
// 	{ id: 'SY', label: 'Syrian Arab Republic', phone: '963' },
// 	{ id: 'SZ', label: 'Swaziland', phone: '268' },
// 	{ id: 'TC', label: 'Turks and Caicos Islands', phone: '1-649' },
// 	{ id: 'TD', label: 'Chad', phone: '235' },
// 	{ id: 'TF', label: 'French Southern Territories', phone: '262' },
// 	{ id: 'TG', label: 'Togo', phone: '228' },
// 	{ id: 'TH', label: 'Thailand', phone: '66' },
// 	{ id: 'TJ', label: 'Tajikistan', phone: '992' },
// 	{ id: 'TK', label: 'Tokelau', phone: '690' },
// 	{ id: 'TL', label: 'Timor-Leste', phone: '670' },
// 	{ id: 'TM', label: 'Turkmenistan', phone: '993' },
// 	{ id: 'TN', label: 'Tunisia', phone: '216' },
// 	{ id: 'TO', label: 'Tonga', phone: '676' },
// 	{ id: 'TR', label: 'Turkey', phone: '90' },
// 	{ id: 'TT', label: 'Trinidad and Tobago', phone: '1-868' },
// 	{ id: 'TV', label: 'Tuvalu', phone: '688' },
// 	{ id: 'TW', label: 'Taiwan, Province of China', phone: '886' },
// 	{ id: 'TZ', label: 'United Republic of Tanzania', phone: '255' },
// 	{ id: 'UA', label: 'Ukraine', phone: '380' },
// 	{ id: 'UG', label: 'Uganda', phone: '256' },
// 	{ id: 'US', label: 'United States', phone: '1', suggested: true },
// 	{ id: 'UY', label: 'Uruguay', phone: '598' },
// 	{ id: 'UZ', label: 'Uzbekistan', phone: '998' },
// 	{ id: 'VA', label: 'Holy See (Vatican City State)', phone: '379' },
// 	{ id: 'VC', label: 'Saint Vincent and the Grenadines', phone: '1-784' },
// 	{ id: 'VE', label: 'Venezuela', phone: '58' },
// 	{ id: 'VG', label: 'British Virgin Islands', phone: '1-284' },
// 	{ id: 'VI', label: 'US Virgin Islands', phone: '1-340' },
// 	{ id: 'VN', label: 'Vietnam', phone: '84' },
// 	{ id: 'VU', label: 'Vanuatu', phone: '678' },
// 	{ id: 'WF', label: 'Wallis and Futuna', phone: '681' },
// 	{ id: 'WS', label: 'Samoa', phone: '685' },
// 	{ id: 'XK', label: 'Kosovo', phone: '383' },
// 	{ id: 'YE', label: 'Yemen', phone: '967' },
// 	{ id: 'YT', label: 'Mayotte', phone: '262' },
// 	{ id: 'ZA', label: 'South Africa', phone: '27' },
// 	{ id: 'ZM', label: 'Zambia', phone: '260' },
// 	{ id: 'ZW', label: 'Zimbabwe', phone: '263' },
// ];
